<script setup>
import { computed, markRaw } from "vue";
import draggable from "vuedraggable";
import { ButtonSecondaryMd } from "@easy/ui/buttons";
import { AddIcon, DragDropIcon, PageIcon } from "@easy/ui/icons";
import { PageSidebar } from "@easy/ui/page-components";
import { CardEmpty } from "@easy/ui/cards";
import { FormDivider } from "@easy/ui/forms";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import SectionListCard from "./SectionListCard.vue";
import { useState, useActions, useMutations } from "@/store/vuex-composition-mappers";

defineEmits(["addSection", "editSection"]);

const { hasChanges, sections } = useState("page", ["hasChanges", "sections"]);
const { saveSnapshot } = useActions("page/projects", ["saveSnapshot"]);
const { setSections } = useMutations("page", ["setSections"]);
const emptyIcon = computed(() => markRaw(PageIcon));

const sectionList = computed({
    get: () => sections.value,
    set: (value) => setSections(value),
});

const addActions = []; // TODO: @Jabi - I did not erase it, but it was not defined on logic!
</script>

<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("page.menu.sections") }} </template>
        <template #sidebarCta>
            <ButtonSecondaryMd @click="$emit('addSection')">
                <AddIcon />
                <span>{{ $t("page.sections.new_section") }}</span>
            </ButtonSecondaryMd>
        </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <draggable v-model="sectionList" item-key="id" @change="setSections()">
                    <template #item="{ element: section }">
                        <div class="relative mt-2 group" v-if="!section._deleted">
                            <SectionListCard
                                class="mb-3 ct-drag-item"
                                :section="section"
                                @click="$emit('editSection', section)"
                            />
                            <div
                                class="absolute top-1/2 -left-3 -translate-y-1/2 ct-fg-4 opacity-0 group-hover:opacity-100 cursor-move pr-2 h-full flex items-center"
                            >
                                <DragDropIcon />
                            </div>
                        </div>
                    </template>
                </draggable>

                <CardEmpty
                    class="w-full"
                    v-if="!sectionList.length"
                    :title="$t('page.empty.title')"
                    :icon="emptyIcon"
                >
                    <div class="w-full space-y-3">
                        <div class="w-full" v-for="action in addActions" :key="action.label">
                            <ButtonSecondaryMd
                                v-if="!action.isDivider"
                                class="w-full"
                                @click="action.handler"
                            >
                                <component v-if="action.icon" :is="action.icon" />
                                <span>{{ action.label }}</span>
                            </ButtonSecondaryMd>
                            <div v-else class="py-2">
                                <FormDivider />
                            </div>
                        </div>
                    </div>
                </CardEmpty>
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>
